import fetchFunc from './fetchFunc.js'
//Usado para armazenar todas as rotas do BackEnd
export const consultaVendedoraProxima = ({CEP})=>fetchFunc.fetchPost('/consultaVendedoraProxima',{CEP})
export const consultaVendProxNFshn = ({CEP})=>fetchFunc.fetchPost('/consultaVendProxNFshn',{CEP})
export const BuscaFotoFashion = ({IMG})=>fetchFunc.fetchPost('/BuscaFotoFashion',{IMG})
export const RegistraAcessos = ({nome_rota, nome_tela})=>fetchFunc.fetchPost('/RegistraAcessos',{nome_rota, nome_tela})
// Registra a "indicacao" (clique no WhatsApp) -> backend joga a revendedora pro fim do rodizio
export const RegistrarCliqueRevendedora = ({CPF})=>fetchFunc.fetchPost('/RegistrarCliqueRevendedoraProxima',{CPF})


export const ConsultaRede = ()=>fetchFunc.fetchGet('/')


const db = {
    consultaVendedoraProxima,
    consultaVendProxNFshn,
    BuscaFotoFashion,
    RegistraAcessos,
    RegistrarCliqueRevendedora
}

export default db;
